import FORM_KEYS from 'apps/web/constants/forms/lesson-plan/formKeys';
import { Portal } from 'apps/web/enums/portal.enum';
import * as yup from 'yup';

import * as fields from './fields';

const LessonPlannerSchema = (portal: Portal) => {
  const isLocal = portal === Portal.PHILIPPINES;
  const isMontessori = portal === Portal.MONTESSORI;
  const isDefault = portal === Portal.DEFAULT;
  const isUSA = portal === Portal.USA;

  const localFields = {
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.lessonFormat]: fields.lessonFormat,
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.objective]: fields.textArea,
    [FORM_KEYS.objective2]: fields.optionalTextArea,
    [FORM_KEYS.objective3]: fields.optionalTextArea,
    [FORM_KEYS.language]: fields.language,
  };

  const defaultFields = {
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.language]: fields.language,
    [FORM_KEYS.time]: fields.time,
    [FORM_KEYS.modality]: fields.modality,
    [FORM_KEYS.objective]: fields.textArea,
    [FORM_KEYS.objective2]: fields.optionalTextArea,
    [FORM_KEYS.objective3]: fields.optionalTextArea,
  };

  // Fields specific to Montessori
  const montessoriFields = {
    [FORM_KEYS.title]: fields.title,
    [FORM_KEYS.classProgram]: fields.subject,
    [FORM_KEYS.materials]: fields.montessoriMaterials,
    [FORM_KEYS.prerequisites]: fields.prerequisite,
    [FORM_KEYS.keyArea]: fields.optionalTextArea,
    [FORM_KEYS.keyArea2]: fields.optionalTextArea,
    [FORM_KEYS.keyArea3]: fields.optionalTextArea,
    [FORM_KEYS.objective]: fields.textArea,
    [FORM_KEYS.objective2]: fields.optionalTextArea,
    [FORM_KEYS.objective3]: fields.optionalTextArea,
    [FORM_KEYS.language]: fields.language,
  };

  const americaFields = {
    [FORM_KEYS.curriculumFramework]: fields.americaCurriculum,
    [FORM_KEYS.gradeLevel]: fields.gradeLevel,
    [FORM_KEYS.subject]: fields.subject,
    [FORM_KEYS.specificStandards]: fields.americaStandard,
    [FORM_KEYS.objective]: fields.textArea,
    [FORM_KEYS.objective2]: fields.optionalTextArea,
    [FORM_KEYS.objective3]: fields.optionalTextArea,
    [FORM_KEYS.strategies]: fields.americaStrategy,
  };
  if (isLocal) {
    return yup.object().shape(localFields);
  }
  if (isUSA) {
    return yup.object().shape(americaFields);
  }

  if (isMontessori) {
    return yup.object().shape(montessoriFields);
  }

  if (isDefault) {
    return yup.object().shape(defaultFields);
  }

  return yup.object().shape(defaultFields);
};

export default LessonPlannerSchema;
